export enum KycStatus {
    approving = "approving",
    pending = "pending",
    checking = "checking",
}